export const TRAINERS_RESET_STATE = 'TRAINERS_RESET_STATE';
export const TRAINERS_CURRENT_ITEM = 'TRAINERS_CURRENT_ITEM';

export const TRAINERS_REQUEST_LOADING = 'TRAINERS_REQUEST_LOADING';
export const TRAINERS_REQUEST_SUCCESS = 'TRAINERS_REQUEST_SUCCESS';
export const TRAINERS_REQUEST_FAILED = 'TRAINERS_REQUEST_FAILED';

export const TRAINERS_CURRENT_ACTION = 'TRAINERS_CURRENT_ACTION';
export const TRAINERS_RESET_ACTION = 'TRAINERS_RESET_ACTION';